import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MaintenanceType } from '../models/maintenance-type.model';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceTypeService {
  private apiUrl = environment.apiUrl + environment.maintenanceTypePath;

  constructor(private http: HttpClient) {}

  getMaintenanceTypes(): Observable<MaintenanceType[]> {
    return this.http.get<MaintenanceType[]>(this.apiUrl);
  }

  getMaintenanceType(id: number): Observable<MaintenanceType> {
    return this.http.get<MaintenanceType>(`${this.apiUrl}/${id}`);
  }

  createMaintenanceType(maintenanceType: MaintenanceType): Observable<MaintenanceType> {
    return this.http.post<MaintenanceType>(this.apiUrl, maintenanceType);
  }

  updateMaintenanceType(id: number, maintenanceType: MaintenanceType): Observable<MaintenanceType> {
    return this.http.put<MaintenanceType>(`${this.apiUrl}/${id}`, maintenanceType);
  }

  deleteMaintenanceType(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }

  disabledMaintenanceType(maintenanceType: MaintenanceType): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}${environment.disabledPath}/${maintenanceType.id}`,
      maintenanceType,
    );
  }
}
